import { render } from "./message-compact.vue?vue&type=template&id=1e156d2f"
import script from "./message-compact.vue?vue&type=script&lang=js"
export * from "./message-compact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__